/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Custom_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter custom name (optional)" |
*
* @param {Embed_Captions_Custom_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_custom_name_placeholder = /** @type {((inputs?: Embed_Captions_Custom_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Custom_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez un nom personnalise (facultatif)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie einen benutzerdefinierten Namen ein (optional).")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nome personalizzato (facoltativo)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите пользовательское имя (необязательно)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca un nombre personalizado (opcional)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输入自定义名称（可选）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタム名を入力してください（オプション）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपना मनचाहा नाम दर्ज करें (वैकल्पिक)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira um nome personalizado (opcional)")
	return /** @type {LocalizedString} */ ("Enter custom name (optional)")
});